import { useQuery } from '@tanstack/react-query'
import { fetchData } from '../../api/fetchJson'
import { orgPath } from '../../config/orgId'
import {
  Card,
  Currency,
  Empty,
  ErrorBanner,
  Loading,
  PageHeader,
} from '../../components/ui'

type Material = {
  id: string
  name: string
  unit?: string
  category?: string
  hsn_code?: string | null
  default_rate?: number | null
}

export function MaterialCatalogPage() {
  const q = useQuery<Material[]>({
    queryKey: ['materials'],
    queryFn: () => fetchData<Material[]>(orgPath('/materials')),
  })

  if (q.isLoading) return <Loading />
  if (q.isError) return <ErrorBanner error={q.error} />

  return (
    <div>
      <PageHeader
        title="Material catalog"
        subtitle="Read-only master list. Edit by re-running the demo seed."
      />
      {!q.data || q.data.length === 0 ? (
        <Empty message="No materials in the demo org yet." hint="Operator: run POST /api/admin/demo/reset." />
      ) : (
        <Card>
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="text-left text-surface-400 border-b border-surface-700">
                  <th className="py-2 pr-4">Name</th>
                  <th className="py-2 pr-4">Unit</th>
                  <th className="py-2 pr-4">Category</th>
                  <th className="py-2 pr-4">HSN</th>
                  <th className="py-2">Default rate</th>
                </tr>
              </thead>
              <tbody>
                {q.data.map((m) => (
                  <tr key={m.id} className="border-b border-surface-700/50">
                    <td className="py-2 pr-4">{m.name}</td>
                    <td className="py-2 pr-4">{m.unit ?? '—'}</td>
                    <td className="py-2 pr-4">{m.category ?? '—'}</td>
                    <td className="py-2 pr-4">{m.hsn_code ?? '—'}</td>
                    <td className="py-2">
                      <Currency amount={m.default_rate ?? null} />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Card>
      )}
    </div>
  )
}
